export default {
      id: "not-forging-usage",
      viewBox: "0 0 19 17",
      url: __webpack_public_path__ + "img/svg.c2d72070.svg#not-forging",
      toString: function () {
        return this.url;
      }
    }